import { render, staticRenderFns } from "./PatientEmailCard.vue?vue&type=template&id=f340d4c6&scoped=true&"
import script from "./PatientEmailCard.vue?vue&type=script&lang=ts&"
export * from "./PatientEmailCard.vue?vue&type=script&lang=ts&"
import style0 from "./PatientEmailCard.vue?vue&type=style&index=0&id=f340d4c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f340d4c6",
  null
  
)

export default component.exports